"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function ScopeBanner() {
  const { t } = useLanguage();
  return (
    <section className="bg-white pb-10 md:pb-12">
      <div className="max-w-[880px] mx-auto px-4 md:px-6">
        <div className="bg-[#ea580c] rounded-xl p-8 md:p-10 text-white text-center">
          <h2 className="text-lg md:text-[22px] font-bold mb-3">
            {t("terms.importantScope")}
          </h2>
          <p className="text-base leading-relaxed max-w-[720px] mx-auto">
            {t("terms.scopeBanner")}
          </p>
        </div>
      </div>
    </section>
  );
}